// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4ba5fcc4","453":"22c9a205","732":"4e7a6668","977":"cdc60909"}[chunkId] + ".chunk.js";
};